import { connect } from 'react-redux';
import HandoffText from '../../components/handoff/HandoffText';
import { getSelectedElement } from '../../selectors/handoff';
import * as handoff from '../../utils/handoff/element';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    return {
        content: handoff.getContent(element),
        style: element.style,
        itemProps: element.itemProps,
    };
}
export default connect(mapStateToProps)(HandoffText);
